/**
 * Created by PERSCITUS-42 on 16-Apr-19.
 */
export class changePwd {
  constructor(
    public password?:string,
    public oldPassword?:string,
    public re_password?:string,
    public user_id ?: string,
    public updated_by ?: string
  ){}
}



// WEBPACK FOOTER //
// ./src/app/models/changePwd.ts